import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
    Add_job_category,
    Get_started,
    Search_service,
    What_service_do_you_offer,
} from '../../helpers/dictionary';
import SearchIcon from '../../svgs/search.svg';
import useGetSearchFunction from '../../hooks/useGetSearchResults';
import { useRouter } from 'next/router';
import Link from 'next/link';

const SearchBoxCss = styled.div`
  padding: 0 1.6rem;
  h2 {
    text-align: center;
    font-weight: 600;
    font-size: 28px;
    line-height: 28px;
  }
  .service {
    display: flex;
    justify-content: space-between;
    position: relative;
    svg {
      position: absolute;
      left: 1rem;
      top: 1.4rem;
      fill: #b5b5be;
      pointer-events: none;
    }
    .search-results {
      position: absolute;
      top: 120%;
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      background: white;
      box-shadow: 0px 63px 50px rgba(67, 67, 68, 0.0705882);
      border-radius: 4px;
      z-index: 4;
      a {
        display: inline-block;
        padding: 1.6rem;
        font-size: 1.2rem;
        font-weight: 600;
        color: #565459;
        min-width: 100%;
        &:hover {
          color: ${(props) => props.theme.colors.frenchViolet};
          background-color: #f4f6fb;
        }
      }
      li.add-category {
        background-color: #f4f6fb;
        display: flex;
        justify-content: center;
      }
      button {
        background-color: transparent;
        border: 0;
        width: auto;
        box-shadow: none;
        display: flex;
        align-items: center;
        padding: 1.6rem 0;
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
        color: var(--color-flickr-blue);
        svg {
          top: 0;
          left: 0;
          margin-right: 0.8rem;
          position: relative;
        }
      }
    }
  }
  input {
    width: 68%;
    background: #ffffff;
    border: 1.5px solid #e2e2e9;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1.6rem 4rem;
    font-size: 14px;
  }
  button {
    width: 30%;
    cursor: pointer;
    background: var(--color-flickr-blue);
    box-shadow: 0px 3px 6px rgba(54, 98, 216, 0.3);
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    border: 0;
  }
  @media (min-width: 768px) {
    padding: 0 3.2rem;
    height: 240px;
  }
  @media (min-width: 1024px) {
    max-width: 600px;
    margin: auto;
  }
`;

function useOutsideAlerter(ref, setShowResults) {
    useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowResults(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
}

const SearchBlock = ({ lang }) => {
    const [showResults, setShowResults] = useState(false);
    const [query, setQuery] = useState('');
    const { searchResults } = useGetSearchFunction(query, lang, true, true);

    const searchResultsRef = useRef(null);
    useOutsideAlerter(searchResultsRef, setShowResults);

    const router = useRouter();

    const switchToPro = router.query.switch;

    return (
        <SearchBoxCss>
            <div className="p-5">
                <h2>{What_service_do_you_offer[lang]}</h2>
                <div className="service">
                    <SearchIcon />
                    <input
                        type="text"
                        placeholder={Search_service[lang]}
                        onClick={() => setShowResults(true)}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <button>{Get_started[lang]}</button>
                    <ul
                        F style={{
                            pointerEvents: showResults ? 'auto' : 'none',
                            opacity: showResults ? 1 : 0,
                        }}
                        ref={searchResultsRef}
                        className="search-results"
                    >
                        {searchResults &&
              searchResults.slice(0, 5).map((result, i) => (
                  <li key={i}>
                      <Link
                          href={
                              switchToPro === 'true'
                                  ? '/switch-to-pro/' + result.id
                                  : '/join-as-pro/' + result.id
                          }
                      >
                          <a>
                              {lang === 'ru'
                                  ? result.titleRU
                                  : lang === 'uz'
                                      ? result.titleUZ
                                      : result.titleEN}
                          </a>
                      </Link>
                  </li>
              ))}
                        {query.length > 0 && (
                            <li className="add-category">
                                <button>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                                            fill="var(--color-flickr-blue)"
                                        />
                                    </svg>
                                    <span>{Add_job_category[lang]}</span>
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </SearchBoxCss>
    );
};

export default SearchBlock;
